import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from "src/app/core/authentication/login.service";
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/helper/local-storage.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private loginService: LoginService,
        private router: Router,
        private localStorageService: LocalStorageService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(e => {
            if ([401, 403].includes(e.status) && this.loginService.isLoggedIn) {
                this.localStorageService.deleteAllLocalStorage();
                this.router.navigateByUrl("/login"); 
            }
            if ([0].includes(e.status) && e.url.includes("email/verify")) {
                this.localStorageService.deleteAllLocalStorage();
                this.router.navigateByUrl("/login"); 
            }
            const error = (e && e.error && e.error.message) || e.statusText;
            return throwError(error);
        }));
    }
}